var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcsCarousel02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.5C12.7941 7.5 7.5 11.6176 7.5 25C7.5 34.3458 10.082 39.173 17.5 41.2348V52.5L27.531 42.469C28.3252 42.49 29.148 42.5 30 42.5C47.206 42.5 52.5 38.3823 52.5 25C52.5 11.6176 47.206 7.5 30 7.5Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15.375H25C23.7591 15.375 22.75 16.3841 22.75 17.625V33.375C22.75 34.6159 23.7591 35.625 25 35.625H34C35.2409 35.625 36.25 34.6159 36.25 33.375V17.625C36.25 16.3841 35.2409 15.375 34 15.375ZM18.25 19.875V31.125C18.25 32.3659 19.2591 33.375 20.5 33.375V17.625C19.2591 17.625 18.25 18.6341 18.25 19.875ZM38.5 17.625V33.375C39.7409 33.375 40.75 32.3659 40.75 31.125V19.875C40.75 18.6341 39.7409 17.625 38.5 17.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcsCarousel02);
export default __webpack_public_path__ + "static/media/rcs_carousel02.7d8b7fb059194a97eab6d3838685415e.svg";
export { ForwardRef as ReactComponent };